export function isUrlQuery(query: string): boolean {
    return (
        query.startsWith('ftp://') ||
        query.startsWith('smb://') ||
        query.startsWith('http://') ||
        query.startsWith('https://')
    );
}
